import {
  Component,
  OnInit,
  Input,
  Output,
  ViewChild,
  TemplateRef,
  EventEmitter,
} from '@angular/core';
import {
  NgbActiveModal,
  NgbModal,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { CustomerCardNumber } from '../../../models/customer.model';
import {
  CardInfo,
  CreditPayment,
  CustomerAddress,
} from '../../../models/invoice/invoice.model';
import { InvoiceService } from '../../../services/invoice.service';
import { CustomerManagementService } from '../../../services/customer.service';
import { AuthorizationBase } from 'src/app/shared/libraries/authorize-base';
import { InvoiceNotesComponent } from './invoice-notes/invoice-notes.component';
import { CreditPaymentService } from '../../../services/creditpayment.service';
import { CustomerAddressFormComponent } from '../../customers/customer-address-form/customer-address-form.component';
import { ServiceWorkOrderService } from '../../../services/service-work-order.service';
import { SourceComponent } from '../../../models/invoice/payment.model';
import { AlertService } from '../../../../core/alert.service';
import { MerchantService } from '../../../services/merchant.service';
import { TermsconditionpolicyService } from '../../../services/termsconditionpolicy.service';
import { HeartlandCardTokenizerComponent } from '../../heartland-card-tokenizer/heartland-card-tokenizer.component';
import { PaymentService } from 'src/app/shared/services/payments.service';
declare var $: any;

@Component({
  selector: 'app-card-form',
  templateUrl: './card-form.component.html',
  styleUrls: ['./card-form.component.scss'],
})
export class CardFormComponent extends AuthorizationBase implements OnInit {
  @ViewChild('container', { static: false }) tcpTemplate: TemplateRef<any>;
  @ViewChild('tokenizerForm', { static: false })
  tokenizerForm: HeartlandCardTokenizerComponent;
  @Output() customerCardAdded = new EventEmitter<number>();

  @Input() customerId: number;
  @Input() amountToBePaid: number;
  @Input() invoiceNumber: string;
  @Input() locationData: any;
  @Input() addressId: number = 0;
  @Input() addressShippingId: number = 0;
  @Input() policyContent: string;
  @Input() termsAndConditionContent: string;
  @Input() isPartialPayment: boolean = false;
  @Input() user_Id: string;
  @Input() merchantName: string = '';

  @Input() isMultipleInvoices: boolean = false;
  @Input() manualInvoices: any[];
  @Input() customerSignature: any;

  @Input() gratuity: number = 0;

  @Input() onCardAdded: any;

  currentModal: NgbModalRef;
  tcpTitle: string;
  tcpContent: string;

  agreedToTerms: boolean = false;
  @Input() saveCard: boolean = false;

  isUpdate: boolean = false;
  busy: boolean = false;
  model: CustomerCardNumber;
  cardToken: any;
  multiUseToken: any;
  cardInfo: CardInfo;
  @Output() publicAPIKey: string;

  customerAddressList: any[];
  manualInvoice: any;
  workOrderModel: any;

  customerAddress: CustomerAddress;
  shippingAddress: CustomerAddress;
  tokenReceived: boolean;

  processor: string;
  businessInfo: any;

  cardBrandTransactionId: string;
  level: string;
  notes: string = '';
  customerEmail: string;

  constructor(
    private creditService: CreditPaymentService,
    private alert: AlertService,
    public apiService: CustomerManagementService,
    private invoiceService: InvoiceService,
    private merchantService: MerchantService,
    private tcpService: TermsconditionpolicyService,
    private modalRef: NgbActiveModal,
    private workOrderSvc: ServiceWorkOrderService,
    private modalService: NgbModal,
    private paymentService: PaymentService,
  ) {
    super();
    this.model = new CustomerCardNumber();
    this.processor = super.getPlatform().toString();

    if (this.processor == 'false') {
      this.loadBusinessInfo();
    }
  }

  ngOnInit() {
    this.busy = true;
    this.cardInfo = new CardInfo();
    this.publicAPIKey = this.locationData ? this.locationData.API_Key : '';

    if (!this.isMultipleInvoices) {
      this.getManualInvoice(this.invoiceNumber);
    }

    this.customerAddress = new CustomerAddress();
    this.shippingAddress = new CustomerAddress();
    this.getCustomerAddress(this.customerId);
    this.getCustomerShippingAddress(this.customerId);
    this.getTermsPolicy();
    this.getCustomerInfo(this.customerId);

    if (!this.customerId) {
      this.addAddress();
    }
  }
  loadBusinessInfo() {
    this.merchantService.getMerchant('1').subscribe((response: any) => {
      if (response) {
        this.businessInfo = response;
        this.processor = response.Processor.toLowerCase();
      }
    });
  }

  getCustomerInfo(customerId: any) {
    this.apiService.getCustomer(customerId).subscribe((res: any) => {
      if (res) {
        this.customerEmail = res.EmailAddress;
        this.level = res.LevelProcessing ? res.LevelProcessing.toString() : '';
      }
    });
  }

  onCardTokenReceived(token) {
    if (this.tokenReceived) return;

    this.cardToken = token;

    if (!this.invoiceNumber) {
      return false;
    }

    if (!token) {
      this.alert.alertError({ text: 'Please input Card details first.' });
      this.tokenizerForm.setBusyState(false);
      return false;
    }

    if (!this.addressId) {
      this.alert.alertError({ text: 'Please select an address.' });
      this.tokenizerForm.setBusyState(false);
      return false;
    }

    if (!this.agreedToTerms) {
      this.alert.alertError({ text: 'Please Agree to Terms and Conditions.' });
      this.tokenizerForm.setBusyState(false);
      return false;
    }

    if (token.card_type == 'amex' && !this.customerAddress.PostalCode) {
      this.alert.alertError({
        text: 'An American Express card requires a zip code for verification and the selected address has no zip code specified. Please edit it via Customers > Edit Customer > Zip Code field.',
      });
      this.tokenizerForm.setBusyState(false);
      return false;
    }

    //added for transit notes requirement
    if (this.processor == 'tsys') {
      if (
        this.cardToken.details.cardType === 'amex' &&
        !this.notes &&
        (this.level === '2' || this.level === '3')
      ) {
        let modal = this.modalService.open(InvoiceNotesComponent, {
          size: 'sm',
        });
        modal.result.then((res: any) => {
          if (res) {
            this.notes = res;
            this.doPayment();
          } else {
            this.alert.alertError({
              text: 'An American Express card requires invoice notes/description for Level 2 or 3 Customers.',
            });
            return false;
          }
        });
      } else {
        this.doPayment();
      }
    } else {
      //continue execute payment for non transit and non level customers
      this.doPayment();
    }
  }

  doPayment() {
    this.tokenReceived = true;
    this.busy = true;
    this.cardInfo.token = this.cardToken.paymentReference;
    this.cardInfo.number = this.cardToken.details.cardLast4;
    this.cardInfo.cardBIN = this.cardToken.details.cardBin;
    this.cardInfo.expMonth = this.cardToken.details.expiryMonth;
    this.cardInfo.expYear = this.cardToken.details.expiryYear;
    this.cardInfo.cvn = this.cardToken.details.cvv;

    var creditData = new CreditPayment();
    creditData.currency = 'USD';
    creditData.cardInfo = this.cardInfo;
    creditData.amount = this.amountToBePaid;
    creditData.invoiceNumber = this.invoiceNumber;
    creditData.terminalId = 'MAIN';
    creditData.customerId = this.customerId;
    creditData.gratuity = this.gratuity || 0;
    if (this.processor == 'tsys') {
      creditData.shippingAddress = this.shippingAddress;
      creditData.Level = this.level ? this.level : '1';
      creditData.Notes = this.notes;
    }

    creditData.billingAddress = this.customerAddress;
    creditData.SourceComponent =
      this.workOrderModel == null || undefined
        ? SourceComponent.ManualInvoice
        : SourceComponent.WorkOrder;
    creditData.TransactionSource =
      this.workOrderModel == null || undefined
        ? SourceComponent.ManualInvoice
        : SourceComponent.WorkOrder;

    this.processPayment();
  }

  getCustomerAddress(id: number) {
    this.busy = true;
    this.apiService.getCustomerAddresses(id).subscribe(
      (res: any) => {
        if (res) {
          this.customerAddressList = res;
          let addr = res.find((addr) => {
            if (this.addressId != 0) {
              return addr.Id === this.addressId;
            } else {
              return addr.IsDefault === true;
            }
          });

          if (addr) {
            this.addressId = addr.Id;
            this.customerAddress.City = addr.City;
            this.customerAddress.State = addr.State;
            this.customerAddress.PostalCode = addr.ZipCode;
            this.customerAddress.StreetAddress1 = addr.StreetAddress;
          }
        }
      },
      (error: any) => {},
      () => {
        this.busy = false;
      }
    );
  }

  getCustomerShippingAddress(id: number) {
    this.busy = true;
    this.apiService.getCustomerAddresses(id).subscribe(
      (res: any) => {
        if (res) {
          //this.customerAddressList = res;
          let addr1 = res.find((addr1) => {
            return addr1.AddressType === 3;
          });

          if (addr1) {
            this.addressShippingId = addr1.Id;
            this.shippingAddress.Id = addr1.Id;
            this.shippingAddress.City = addr1.City;
            this.shippingAddress.State = addr1.State;
            this.shippingAddress.PostalCode = addr1.ZipCode;
            this.shippingAddress.StreetAddress1 = addr1.StreetAddress;
          }
        }
      },
      (error: any) => {},
      () => {
        this.busy = false;
      }
    );
  }

  addAddress() {
    let cardDiag = this.modalService.open(CustomerAddressFormComponent, {
      size: 'lg',
    });
    cardDiag.componentInstance.customerId = this.customerId;

    cardDiag.result.then((res: CustomerAddress) => {
      if (res) {
        this.customerAddressList.push(res);
        this.addressId = res.Id;
        this.addressSelected();
      }
    });
  }

  addressSelected() {
    var addr = this.customerAddressList.find((addr) => {
      return addr.Id == this.addressId;
    });
    if (addr) {
      this.customerAddress.City = addr.City;
      this.customerAddress.State = addr.State;
      this.customerAddress.PostalCode = addr.ZipCode;
      this.customerAddress.StreetAddress1 = addr.StreetAddress;
    }
  }

  addressShippingSelected() {
    var addr1 = this.customerAddressList.find((addr1) => {
      return addr1.Id == this.addressShippingId;
    });
    if (addr1) {
      this.shippingAddress.City = addr1.City;
      this.shippingAddress.State = addr1.State;
      this.shippingAddress.PostalCode = addr1.ZipCode;
      this.shippingAddress.StreetAddress1 = addr1.StreetAddress;
    }
  }

  getManualInvoice(invoiceNumber: string) {
    this.busy = true;
    this.invoiceService
      .getManualInvoice(invoiceNumber)
      .subscribe((res: any) => {
        if (res) {
          this.manualInvoice = res;
          this.notes = this.manualInvoice.notes; //added for transit
          this.workOrderSvc
            .getWorkOrderByInvoice(invoiceNumber)
            .subscribe((workOrderRes) => {
              if (workOrderRes) {
                this.workOrderModel = workOrderRes;
              }
            });
        }
        this.busy = false;
      });
  }

  processPayment() {
    if (this.isMultipleInvoices) {
      this.processMultiplePayment();
      return;
    }
    this.busy = true;
    /*SANDBOX PAYMENT TESTING
        this.cardInfo.MID = "MyGlobalPaymentsDemo";
        this.cardInfo.token = "EN67b51NfsKEYZvAOPR1111";
        this.cardInfo.secretApiKey = "skapi_cert_MYl2AQAowiQAbLp5JesGKh7QFkcizOP2jcX9BrEMqQ"
    */
    this.cardInfo.number = this.cardToken.details.cardLast4;
    this.cardInfo.cvn = this.cardToken.details.cvv;
    this.cardInfo.cardType = this.cardToken.details.cardType;

    var creditData = new CreditPayment();
    creditData.currency = 'USD';
    creditData.cardInfo = this.cardInfo;
    creditData.amount = this.amountToBePaid;
    creditData.invoiceNumber = this.invoiceNumber;
    creditData.terminalId = 'MAIN';
    creditData.customerId = this.customerId;
    creditData.isPartialPayment = this.isPartialPayment;
    creditData.gratuity = this.gratuity || 0;
    creditData.requestMultiUseToken = this.saveCard;

    if (this.processor == 'tsys') {
      creditData.Level = this.level ? this.level : '1';
      creditData.shippingAddress = this.shippingAddress;
      creditData.Notes = this.notes;
    }
    let locId = '';

    if (this.manualInvoice && this.manualInvoice.locationId != null) {
      locId = this.manualInvoice.locationId.toString();
    }

    creditData.billingAddress = this.customerAddress;

    creditData.SourceComponent =
      this.workOrderModel == null || undefined
        ? SourceComponent.ManualInvoice
        : SourceComponent.WorkOrder;
    creditData.TransactionSource =
      this.workOrderModel == null || undefined
        ? SourceComponent.ManualInvoice
        : SourceComponent.WorkOrder;

    this.busy = true;
    this.creditService
      .creditChargeOnly(
        creditData,
        this.user_Id,
        locId || this.locationData.Id,
        'Main'
      )
      .subscribe(
        (res: any) => {
          if (res) {
            if (this.customerSignature) {
              //save customer signature.
              this.invoiceService
                .uploadCustomersig({
                  invoiceNumber: this.invoiceNumber,
                  signatureUrl: this.customerSignature,
                  createdBy: this.user_Id || '1',
                })
                .subscribe((res) => {});
            }

            //audit trail
            this.creditService.addAuditTrail(res).subscribe(
              (auditres: any) => {
                if (auditres) {
                  //audit trail successful
                }
              },
              (err) => {
                this.alert.alertError({
                  title: 'Payment successful but audit trail failed',
                  text: err.error,
                });
              },
              () => {
                //send receipt
                const payload = {
                  emailAddress: this.customerEmail,
                  mobileNumber: null,
                  paymentMethod: 'Credit',
                  receiptNumber: res.receiptNumber,
                }

                this.paymentService.sendReceipt(payload).subscribe(
                  (receiptres: any) => {
                    if (receiptres) {
                      //send receipt successful
                    }
                  },
                  (err) => {
                    this.alert.alertWarning({
                      title: `Payment Successful<br>Sending Receipt Failed`,
                      text: `Your payment was done successfully.<br> Unfortunately, there was an error encountered
                      while sending the receipt.<br>
                      <br><br>Please contact ${this.merchantName} and request for the receipt to be sent to your email.`,
                    }).then(result => {
                      if (result.isDismissed || result.isConfirmed) {
                        this.processTip(res);
                      }
                    });
                  },
                  () => {
                    this.processTip(res); 
                  }
                );
              }
            );
          }
        },
        (err) => {
          // this.alert.alertError({ title: "Payment failed", text: err.error });
          if (err.error.toLowerCase().indexOf('authorization') >= 0) {
            this.alert.alertSuccess({
              title: 'Success',
              text: 'Authorization successful.',
            });
            if (this.saveCard) {
              this.saveCardToFile();
              this.busy = false;
            }
          } else {
            this.alert.alertError({
              title: 'Payment failed',
              text: err.error,
            });
            this.tokenizerForm.setBusyState(false);
          }
          this.busy = false;
          this.tokenReceived = false;
        }
      );
  }

  processMultiplePayment() {
    this.busy = true;
    for (var i = 0; i < this.manualInvoices.length; i++) {
      this.cardInfo.number = this.cardToken.details.cardLast4;
      this.cardInfo.cvn = this.cardToken.details.cvv;
      this.cardInfo.cardType = this.cardToken.details.cardType;

      var creditData = new CreditPayment();
      creditData.currency = 'USD';
      creditData.cardInfo = this.cardInfo;
      creditData.amount = this.isPartialPayment
        ? this.manualInvoices[i].ManualInvoice.requiredPartialPayment
        : this.manualInvoices[i].ManualInvoice.balance -
          this.manualInvoices[i].ManualInvoice.totalPaid;
      creditData.invoiceNumber =
        this.manualInvoices[i].ManualInvoice.invoiceNumber;
      creditData.terminalId = 'MAIN';
      creditData.customerId = this.customerId;
      creditData.isPartialPayment = this.isPartialPayment;
      creditData.gratuity = this.gratuity || 0;
      creditData.requestMultiUseToken = this.saveCard;

      var locId = '';

      if (this.manualInvoices[i].locationData.Id != null) {
        locId = this.manualInvoices[i].locationData.Id.toString();
      }
      if (this.processor == 'tsys') {
        creditData.shippingAddress = this.shippingAddress;
        creditData.Level = this.level ? this.level : '1';
        creditData.Notes = this.notes;
      }
      creditData.billingAddress = this.customerAddress;
      creditData.SourceComponent =
        this.workOrderModel == null || undefined
          ? SourceComponent.ManualInvoice
          : SourceComponent.WorkOrder;
      creditData.TransactionSource =
        this.workOrderModel == null || undefined
          ? SourceComponent.ManualInvoice
          : SourceComponent.WorkOrder;

      this.busy = true;
      this.creditService
        .creditChargeOnly(
          creditData,
          this.manualInvoices[i].ManualInvoice.createdBy || '1',
          locId || this.manualInvoices[i].locationData.Id,
          'Main'
        )
        .subscribe(
          (res: any) => {
            if (res) {
              if (this.customerSignature) {
                //save customer signature.
                this.invoiceService
                  .uploadCustomersig({
                    invoiceNumber: res.card.invoiceNumber,
                    signatureUrl: this.customerSignature,
                    createdBy: res.user_Id,
                  })
                  .subscribe((res) => {});
              }
              //audit trail
              this.creditService.addAuditTrail(res).subscribe(
                (auditres: any) => {
                  if (auditres) {
                    //audit trail successful
                  }
                },
                (err) => {
                  this.alert.alertError({
                    title: 'Payment successful but audit trail failed',
                    text: err.error,
                  });
                },
                () => {
                  //send receipt
                  const payload = {
                    emailAddress: this.customerEmail,
                    mobileNumber: null,
                    paymentMethod: 'Credit',
                    receiptNumber: res.receiptNumber,
                  }

                  this.paymentService.sendReceipt(payload).subscribe(
                    (receiptres: any) => {
                      if (receiptres) {
                        //send receipt successful
                      }
                    },
                    (err) => {
                      this.alert.alertWarning({
                        title: `Payment Successful<br>Sending Receipt Failed`,
                        text: `Your payment was done successfully.<br> Unfortunately, there was an error encountered
                        while sending the receipt.<br>
                        <br><br>Please contact ${this.merchantName} and request for the receipt to be sent to your email.`,
                      }).then(result => {
                        if (result.isDismissed || result.isConfirmed) {
                          this.processTip(res);
                        }
                      });
                    },
                    () => {
                      this.processTip(res);
                    }
                  );
                }
              );
            }
          },
          (err) => {
            this.alert.alertError({
              title: 'Payment failed',
              text: err.error,
            });
            this.busy = false;
          }
        );
    }
  }

  processTip(data: any) {
    this.creditService.processTip(data).subscribe(
      (tipres: any) => {
        if (tipres) {
          //tip processing successful
        }
      },
      (err) => {
        this.alert.alertError({
          title:
            'Payment successful but tip processing failed',
          text: err.error,
        });
      },
      () => {
        this.close(true);
        if (this.saveCard) {
          this.cardInfo.cardBrandTransactionId =
            data.transaction.cardBrandTransactionId;
          this.cardInfo.token = data.transaction.token;
          this.saveCardToFile();
        }
        this.busy = false;
      }
    );
  }

  close(data?: any) {
    this.modalRef.close(data);
  }

  getTermsPolicy() {
    this.tcpService.getTerms().subscribe((res: any) => {
      if (res) {
        let term = res.filter((item) => {
          return item.Type === 1 && item.IsDefault;
        })[0];

        let policy = res.filter((item) => {
          return item.Type === 2 && item.IsDefault;
        })[0];

        if (term) {
          this.termsAndConditionContent = term.Content;
        }

        if (policy) {
          this.policyContent = policy.Content;
        }
      }
    });
  }

  openTermsAndCondition() {
    this.tcpTitle = 'Terms and Conditions';
    this.tcpContent = this.termsAndConditionContent;
    this.currentModal = this.modalService.open(this.tcpTemplate, {
      size: 'lg',
    });
  }

  openPolicy() {
    this.tcpTitle = 'Policy';
    this.tcpContent = this.policyContent;
    this.currentModal = this.modalService.open(this.tcpTemplate, {
      size: 'lg',
    });
  }

  closeCurrentDialog() {
    this.currentModal.close();
  }

  saveCardToFile() {
    this.model.Token = this.cardInfo.token;
    this.model.CardLast4Digits = this.cardToken.details.cardLast4;
    this.model.CardBrand = this.cardToken.details.cardType;
    this.model.ExpMonth = this.cardToken.details.expiryMonth;
    this.model.ExpYear = this.cardToken.details.expiryYear;
    this.model.CVN = this.cardToken.details.cvv;
    this.model.CardBrandTransactionId = this.cardInfo.cardBrandTransactionId;

    this.model.IsDeleted = false;
    this.model.CreatedBy = 2;
    this.model.CreatedDate = new Date();
    this.model.UpdatedBy = null;
    this.model.UpdatedDate = null;
    this.model.Id = 0;
    this.model.CustomerId = this.customerId;

    this.apiService.addCustomerCardNumber(this.model).subscribe((res: any) => {
      this.customerCardAdded.emit(res); //must emit.
      if (res) {
        this.alert.alertSuccess({
          title: 'Success',
          text: 'Successfully added card to file.',
        });
        this.busy = false;
        this.modalRef.close(true);
      }
    });
  }
}
